import { render, staticRenderFns } from "./ChartDoughnut.vue?vue&type=template&id=5edf1eac&scoped=true&"
import script from "./ChartDoughnut.vue?vue&type=script&lang=js&"
export * from "./ChartDoughnut.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5edf1eac",
  null
  
)

export default component.exports